import { COLOUR_FACET_GROUP } from "../../constants";

export const getHasMoreColours = ({ facetGroupings = [] }) =>
  !!facetGroupings?.some(facetGroup => facetGroup.type === COLOUR_FACET_GROUP);
